module.exports = __webpack_public_path__ + "static/headshot-samuel-keeley.8bae1fcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-samuel-keeley.jpg
// module id = 533
// module chunks = 152909308826437